import React, { useContext, useEffect, useState } from 'react'
import { CustomModal } from '../../CustomModal/CustomModal';
import { Button, Spinner } from 'reactstrap';
import { t } from 'i18next';
import { EmptyStateOne } from '../../Empty/EmptyStateOne';
import errorIcon from '../../../assets/icons/triangule-exclamation.svg';
import sectorSuccessIcon from '../../../assets/icons/sector-success-icon.svg';
import { getCurrentItems } from '../../../helpers/helpers';
import CustomPagination from '../../CustomPagination/CustomPagination';
import { SectorsSearcher } from './SectorsSearcher';
import { ListOfSectors } from './ListOfSectors';
import SectorsManagementContext from '../../../context/SectorsContext/SectorsManagementContext';

export const SectorsManagement = () => {

    const { sectorsManagementState, getSectorsManagement, cleanSectorsState, deleteSector } = useContext(SectorsManagementContext);
    const { sectorsToConfig, responseSectorsService, isFetching } = sectorsManagementState;

    const [options, setOptions] = useState([]);

    const [showWarningModalToDelete, setShowWarningModalToDelete] = useState({
        active: false,
        sector: {}
    });

    const [pageNumber, setPageNumber] = useState(1);

    const itemsPerPage = 10;

    const currentSectors = getCurrentItems(options, pageNumber, itemsPerPage)

    const totalPages = Math.ceil(options.length / itemsPerPage);

    const handlePageChange = (newPage) => {
        setPageNumber(newPage);
    };

    const handleChangeSearchText = async (value) => {
        if (sectorsToConfig.length) {
            value = value.toLowerCase();

            const filteredObjects = sectorsToConfig.filter((opt) => {
                return opt.sectorName.toLowerCase().includes(value);
            });

            setOptions(filteredObjects);
        }
    }

    const openWarningModalToDelete = (sector) => setShowWarningModalToDelete({ active: true, sector: sector });
    const closeWarningModalToDelete = async () => setShowWarningModalToDelete({ active: false, sector: {} });

    const deleteBuildingAndRefresh = async () => {
        closeWarningModalToDelete();
        await deleteSector(showWarningModalToDelete.sector.sectorId);
    }

    const undertoodAndRefresh = async () => await getSectorsManagement();

    useEffect(() => {
        getSectorsManagement(null, null);
        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        setOptions(sectorsToConfig);
        cleanSectorsState();
        // eslint-disable-next-line
    }, [sectorsToConfig]);

    return (
        <>

            <CustomModal showModal={responseSectorsService.show} centered={true} setShowModal={undertoodAndRefresh}>
                <div className='d-flex flex-column align-items-center justify-content-center'>
                    <img src={responseSectorsService.type === 'ERROR' ? errorIcon : sectorSuccessIcon} alt="" />
                    <p className='mt-3 text-center param-section-title'>{responseSectorsService.text}</p>
                    <p type="button" className='custom-modal-btn-ok' onClick={undertoodAndRefresh}>{t('UNDERSTOOD')}</p>
                </div>
            </CustomModal>

            <CustomModal showModal={showWarningModalToDelete.active} centered={true} setShowModal={closeWarningModalToDelete}>
                <div className='d-flex flex-column align-items-center justify-content-center'>
                    <img src={errorIcon} alt="" />
                    <p className='mt-3 text-center param-section-title'>{`${t('ARE_YOU_SURE_DELETE')} ${showWarningModalToDelete.sector.sectorName} ?`}</p>
                </div>
                <div className='d-flex align-items-center justify-content-around'>
                    <div>
                        <p type='button' className='m-0' onClick={() => closeWarningModalToDelete()}>{t('CANCEL')}</p>
                    </div>
                    <div>
                        <Button style={{ color: '#FFFF' }} className='btn-danger' onClick={() => deleteBuildingAndRefresh()}>
                            {t('DELETE')}
                        </Button>
                    </div>
                </div>
            </CustomModal >

            <SectorsSearcher handleChangeSearchText={handleChangeSearchText} />

            {isFetching ?
                <div className="d-flex mt-4 justify-content-center">
                    <Spinner />
                </div>

                :

                <div className='itemsList'>
                    {
                        currentSectors.length ?
                            currentSectors.map((sector, i) => {
                                return (
                                    <div key={i} className='mb-2'>
                                        <ListOfSectors
                                            sector={sector}
                                            openWarningModalToDelete={openWarningModalToDelete}
                                        />
                                    </div>
                                )
                            })
                            : <div><EmptyStateOne message={t('NO_DATA_SEARCH')} /></div>
                    }
                </div>
            }

            <div className="d-flex justify-content-center">
                <CustomPagination
                    totalPages={totalPages}
                    page={pageNumber}
                    setPage={handlePageChange}
                />
            </div>
        </>
    )
}
